import { render, staticRenderFns } from "./FormFornecedorEnderecos.vue?vue&type=template&id=60ff6415"
import script from "./FormFornecedorEnderecos.vue?vue&type=script&lang=js"
export * from "./FormFornecedorEnderecos.vue?vue&type=script&lang=js"
import style0 from "./FormFornecedorEnderecos.vue?vue&type=style&index=0&id=60ff6415&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports